import * as React from 'react';
import * as b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { actions } from 'shared/actions/app';
import { useDispatch } from 'react-redux';
import { OverlayProps } from 'components/SingleTooltip';

import './index.scss';

import * as plus from './static/img/iconPlus.svg';

interface Props {}

type Enhanced = Props & OverlayProps;

const b = b_.with('idea-landing-submit-section-ipo-notification-tooltip');

export const TooltipContent: React.FC<Enhanced> = ({ close }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const deposit = () => dispatch(actions.showDepositModal({ value: 500, currency: 'USD' }));

  const onDepositClick = () => {
    close();
    deposit();
  };

  return (
    <div className="rc-overlay idea-landing-submit-section-ipo-notification-tooltip__overlay">
      <div className={b()}>
        <div className={b('paragraph')}>
          <b>{t('What is the risk')}</b>
          <br />
          {t('When you apply for a small amount, theres a high chance')}.
        </div>
        <div className={b('paragraph')}>
          <b>{t('Why it happens')}</b>
          <br />
          {t(
            'When a user submits an application for buying shares, it may be fulfilled for 100% and for 1% This percentage is unknown to anyone until IPO is held and is equal for all investors'
          )}
          .
        </div>
        <div className={b('paragraph')}>
          <b>{t('What to do')}</b>
          <br />
          {t(
            'We recommend you invest at least in the range of $ 2000 to $6000 depending on the idea'
          )}
          .
        </div>
        <button className={b('btn', { primary: true })} onClick={onDepositClick}>
          <img className={b('btn-icon')} src={plus} alt="" />
          {t('Deposit funds to account')}
        </button>
      </div>
    </div>
  );
};
